import { render, staticRenderFns } from "./lPage.vue?vue&type=template&id=68e45458&scoped=true&"
import script from "./lPage.vue?vue&type=script&lang=js&"
export * from "./lPage.vue?vue&type=script&lang=js&"
import style0 from "./lPage.vue?vue&type=style&index=0&id=68e45458&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e45458",
  null
  
)

export default component.exports